import type { AppDetailsLink } from '@atlassian/mpac-types';

export const getMailToLink = (appName: string, appKey: string, appDetailsLink: AppDetailsLink) => {
  const subject = encodeURIComponent(`Check out this great Atlassian Marketplace app: ${appName}`);
  const body = encodeURIComponent(
    `Hello favorite admin,\n\nI was browsing Atlassian Marketplace and found an app I think is useful for our organisation: ${appName}.\n\nYou can check it out here: ${appDetailsLink.expand(
      { appKey }
    )}\n\nThanks!`
  );
  return `mailto:?subject=${subject}&body=${body}`;
};
